































import { Component, Vue, Prop, Watch, ProvideReactive } from 'vue-property-decorator';
import AssetCard from '@/components/AssetCard.vue';
import { slideQuery } from '@/services/graph/slide.graph';
import Slide from '@/interfaces/models/Slide';
import { changeQuery } from '../../router';
import SubscriptionBoundary from '../SubscriptionBoundary.vue';

@Component({
  components: {
    AssetCard,
    subscription: SubscriptionBoundary
  }
})
export default class AssetCardDataBoundary extends Vue {
  private isLoading = false;
  private data = {};

  @Prop({ type: String }) assetId?: string;

  @Watch('assetId', { immediate: true })
  onAssetIdChange(assetId: string) {
    const attrs = this.$attrs;
    if (
      assetId &&
      (!attrs['image-set'] ||
        !attrs['deletion'] ||
        !attrs['assignedTo'] ||
        !attrs['localization'] ||
        !attrs['workflow'] ||
        !attrs['tasks'])
    ) {
      this.getAssetData();
    }
  }

  open(id: string) {
    changeQuery({ asset: id });
  }

  async getAssetData(isSoftLoading: boolean = false) {
    if (this.assetId && !this.isLoading) {
      try {
        this.isLoading = !isSoftLoading;
        const {
          imageSet,
          assignedTo,
          tasks,
          _id,
          deletion,
          localization,
          workflow,
          name,
          externalId,
          updatedAt,
          references,
          animationSlides,
          popupSlides,
          zinc,
          workflowStatus
        } = await slideQuery(this.assetId);
        this.data = {
          item: {
            name,
            zinc,
            workflowStatus,
            externalId,
            references,
            popupSlides,
            animationSlides,
            _id
          },
          deletion,
          imageSet,
          assignedTo,
          tasks,
          localization,
          workflow
        };
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    }
  }
}
